module.exports = __webpack_public_path__ + "img/shoulou.9341c84b.png";